export default __webpack_public_path__ + "static/media/obelisk.e63d15a3.png";